[
    {
        "tag": "Удобства в отеле",
        "list": [
            {"id": "wi-fi", "label": "Wi-Fi"},
            {"id": "pool", "label": "Бассейн"},
            {"id": "sauna", "label": "Сауна"},
            {"id": "elevator", "label": "Лифт"},
            {"id": "pets-allowed", "label": "Можно с животными"},
            {"id": "fitness", "label": "Фитнес"},
            {"id": "parking", "label": "Парковка"},
            {"id": "babysitting", "label": "Присмотр за детьми"},
            {"id": "thermal-pool", "label": "Термальный бассейн или бассейн с минеральной либо морской водой"},
            {"id": "accessible", "label": "Удобства для людей с ограниченными физическими возможностями"},
            {"id": "electric-car-charging", "label": "Зарядка электромобиля"}
        ]
    },
    {
        "tag": "Оснащение номеров в отеле",
        "list": [
            { "id": "air-conditioner", "label": "Кондиционер" },
            { "id": "robe", "label": "Халат" },
            { "id": "hair-dryer", "label": "Фен" },
            { "id": "pets-allowed", "label": "Разрешены домашние животные" },
            { "id": "hypoallergenic-rooms", "label": "Гипоаллергенные номера" },
            { "id": "balcony", "label": "Балкон" },
            { "id": "bidet", "label": "Биде" },
            { "id": "bath", "label": "Ванна" },
            { "id": "view-from-window", "label": "Вид из окна" },
            { "id": "shower", "label": "Душевая кабинка" },
            { "id": "coffee-maker", "label": "Кофеварка" },
            { "id": "kettle", "label": "Чайник" },
            { "id": "kitchen", "label": "Кухня" },
            { "id": "mini-bar", "label": "Мини-бар" },
            { "id": "carpet", "label": "Ковровое покрытие" },
            { "id": "no-carpet", "label": "Без ковровый пол" }
        ]
    },
    {
        "tag": "Показания к лечению",
        "list": [
            {"id": "musculoskeletal", "label": "Болезни костно-мышечной системы (опорно-двигательного аппарата)"},
            {"id": "gastrointestinal", "label": "Болезни органов пищеварения (желудочно-кишечного тракта)"},
            {"id": "endocrine", "label": "Болезни эндокринной системы, расстройства питания и нарушение обмена веществ"},
            {"id": "urinary", "label": "Болезни почек, мочевыводящих путей"},
            {"id": "respiratory", "label": "Болезни органов дыхания"},
            {"id": "gynecological", "label": "Заболевания женских половых органов (гинекологические)"},
            {"id": "andrological", "label": "Болезни мужской половой системы (андрологические)"},
            {"id": "cardiovascular", "label": "Болезни системы кровообращения (сердечно-сосудистые заболевания)"},
            {"id": "skin", "label": "Болезни кожи и подкожной клетчатки"},
            {"id": "oncological", "label": "Реабилитация онкологических больных"},
            {"id": "children", "label": "Санаторно-курортное лечение и оздоровление детей"}
        ]
    },
    {
        "tag": "Лечебная база отеля",
        "list": [
            {"id": "acupressure", "label": "Акупрессура (точечный массаж)"},
            {"id": "acupuncture", "label": "Акупунктура (иглоукалывание)"},
            {"id": "blood-test", "label": "Анализ крови"},
            {"id": "anti-rheumatic-bath", "label": "Антиревматическая ванна"},
            {"id": "anticellulite-massage", "label": "Антицеллюлитный массаж"},
            {"id": "lymphatic-drainage-massage", "label": "Аппаратный лимфодренажный массаж"},
            {"id": "aromatic-massage", "label": "Ароматический массаж"},
            {"id": "aerobics", "label": "Аэробика"},
            {"id": "ayurveda", "label": "Аюрведа"},
            {"id": "mineral-water-pool", "label": "Бассейн с минеральной водой"},
            {"id": "thermal-water-pool", "label": "Бассейн с термальной водой"},
            {"id": "bioptron", "label": "Биоптрон"},
            {"id": "biostim-lamp", "label": "Биостимул-биолампа"},
            {"id": "biocon", "label": "BioCon"},
            {"id": "vacuum-massage", "label": "Вакуумный массаж"},
            {"id": "herbal-bath", "label": "Ванна с травяными добавками"},
            {"id": "vibration-platform", "label": "Вибрационная платформа"},
            {"id": "wine-bath", "label": "Винная ванна"},
            {"id": "whirlpool-foot-bath", "label": "Вихревые ванны для ног"},
            {"id": "whirlpool-hand-bath", "label": "Вихревые ванны для рук"},
            {"id": "ascending-shower", "label": "Восходящий душ"},
            {"id": "co2-injections", "label": "Газовые уколы СО2 (карбокситерапия)"},
            {"id": "galvanic-bath", "label": "Гальваническая ванна"},
            {"id": "gastroscopy", "label": "Гастроскопия"},
            {"id": "hydroxer", "label": "Гидроксер"},
            {"id": "pool-exercise", "label": "Гимнастика в бассейне"},
            {"id": "gym-exercise", "label": "Гимнастика в спортзале"},
            {"id": "hyperbaric-chamber", "label": "Гипербарическая камера"},
            {"id": "mud-bath", "label": "Грязевая ванна"},
            {"id": "mud-applications", "label": "Грязевые аппликации"},
            {"id": "mud-vaginal-tampons", "label": "Грязевые вагинальные тампоны"},
            {"id": "mud-wraps", "label": "Грязевые обертывания"},
            {"id": "mud-packs", "label": "Грязевые пакеты"},
            {"id": "diadynamotherapy", "label": "Диадинамотерапия"},
            {"id": "diathermy", "label": "Диатермия"},
            {"id": "diet-therapy", "label": "Диетотерапия (лечебное питание)"},
            {"id": "remote-electrotherapy", "label": "Дистанционное электролечение"},
            {"id": "kneipp-path", "label": "Дорожка Кнейпа"},
            {"id": "charcot-shower", "label": "Душ Шарко"},
            {"id": "breathing-exercises", "label": "Дыхательная гимнастика (пилатес)"},
            {"id": "pearl-bath", "label": "Жемчужная ванна"},
            {"id": "pearl-bath-additives", "label": "Жемчужная ванна с добавками"},
            {"id": "impulse-magnetotherapy", "label": "Импульсная магнитотерапия"},
            {"id": "inhalation", "label": "Ингаляции"},
            {"id": "individual-physiotherapy", "label": "Индивидуальная физиотерапия"},
            { "id": "indian-massage", "label": "Индийский массаж" },
            { "id": "interference-therapy", "label": "Интерференцтерапия" },
            { "id": "yoga", "label": "Йога" },
            { "id": "iodobrom-bath", "label": "Йодобромная ванна" },
            { "id": "cedar-barrel", "label": "Кедровая бочка (фитосауна)" },
            { "id": "kinesio-taping", "label": "Кинезиотейпинг" },
            { "id": "cryotherapy", "label": "Криотерапия" },
            { "id": "laser-therapy", "label": "Лазеротерапия" },
            { "id": "lymphatic-drainage-face", "label": "Лимфодренаж лица" },
            { "id": "local-cryotherapy", "label": "Локальная криотерапия" },
            { "id": "magnetotherapy", "label": "Магнитотерапия" },
            { "id": "magneto-stym", "label": "Magneto Stym" },
            { "id": "manual-lymphatic-drainage-massage", "label": "Мануальный лимфодренажный массаж" },
            { "id": "stone-massage", "label": "Массаж камнями" },
            { "id": "face-massage", "label": "Массаж лица" },
            { "id": "honey-massage", "label": "Массаж с медом" },
            { "id": "mineral-bath", "label": "Минеральная ванна" },
            { "id": "myostimulator", "label": "Миостимулятор" },
            { "id": "general-massage", "label": "Общий массаж" },
            { "id": "oxygen-therapy", "label": " Оксигенотерапия (кислородотерапия)" },
            { "id": "gum-irrigation", "label": " Орошение десен" },
            { "id": "parafango", "label": " Парафанго" },
            { "id": "paraffin-wrap", "label": " Парафиновое обертывание" },
            { "id": "beer-bath", "label": " Пивная ванна" },
            { "id": "body-peeling", "label": " Пилинг тела" },
            { "id": "drinking-treatment", "label": " Питьевое лечение" },
            { "id": "plantoscopy", "label": " Плантоскопия" },
            { "id": "source-water", "label": " Подведена вода из источника" },
            { "id": "underwater-ultrasound-therapy", "label": " Подводная ультразвуковая терапия" },
            { "id": "underwater-spinal-traction", "label": " Подводное вытяжение позвоночника" },
            { "id": "underwater-massage", "label": " Подводный массаж" },
            { "id": "intestinal-washing", "label": " Промывание кишечника" },
            { "id": "pulse-oximetry", "label": " Пульсоксиметрия" },
            { "id": "reflex-massage", "label": " Рефлекторный массаж" },
            { "id": "foot-reflex-massage", "label": " Рефлекторный массаж стоп" },
            { "id": "sulfur-bath", "label": " Серная ванна" },
            { "id": "nordic-walking", "label": " Скандинавская ходьба" },
            { "id": "own-balneocenter", "label": " Собственный бальнеоцентр" },
            { "id": "solux", "label": " Соллюкс" },
            { "id": "salt-room", "label": " Соляная комната" },
            { "id": "spa-capsule-oceania", "label": " Спа-капсула «Океания»" },
            { "id": "dry-hydromassage-bath", "label": " Сухая гидромассажная ванна" },
            { "id": "dry-carbonic-bath", "label": " Сухая углекислая ванна" },
            { "id": "thai-massage", "label": " Тайский массаж" },
            { "id": "thalassotherapy", "label": "Талассотерапия" },
            { "id": "thermal-bath", "label": "Термальная ванна" },
            { "id": "spinal-traction", "label": "Тракция позвоночника (вытягивание позвоночника)" },
            { "id": "ultrasound-diagnosis", "label": "УЗИ-диагностика" },
            { "id": "carbonic-bath", "label": "Углекислая ванна" },
            { "id": "shockwave-therapy", "label": "Ударно-волновая терапия" },
            { "id": "ultrasound", "label": "Ультразвук" },
            { "id": "finnish-sauna", "label": "Финская сауна" },
            { "id": "floating", "label": "Флоатинг" },
            { "id": "circular-shower", "label": "Циркулярный душ" },
            { "id": "partial-massage", "label": "Частичный массаж" },
            { "id": "four-chamber-galvanic-bath", "label": "Четырехкамерная гальваническая ванна" },
            { "id": "extremiter", "label": "Экстремитер" },
            { "id": "ecg", "label": "Электрокардиограмма (ЭКГ)" },
            { "id": "electromagnetic-therapy", "label": "Электромагнитная терапия" },
            { "id": "endo-vaco", "label": "Эндо-вако" },
            { "id": "endogenous-breathing", "label": "Эндогенное дыхание" }
        ]
    },
    {
        "tag": "СПЕЦИАЛЬНОЕ ПИТАНИЕ",
        "list": [
            { "id": "no-gluten", "label": "Безглютеновое меню" },
            { "id": "vegetarian", "label": "Вегетарианское меню" },
            { "id": "dietary", "label": "Диетическое питание" }
        ]
    },
    {
        "tag":"ПРИРОДНЫЕ ЛЕЧЕБНЫЕ ФАКТОРЫ",
        "list":                [
            { "id": "thermal-water", "label": "Термальная вода" },
            { "id": "alkaline-water", "label": "Щелочная вода" },
            { "id": "natural-muds", "label": "Природные грязи" },
            { "id": "radon-water", "label": "Радоновая вода" }
        ]
    },
    {
        "tag":"Профильные специалисты отеля",
        "list":[
            { "id": "dietician", "label": "Диетолог" },
            { "id": "pediatrician", "label": "Педиатр" },
            { "id": "physiotherapist", "label": "Физиотерапевт" },
            { "id": "oncologist", "label": "Онколог" },
            { "id": "kinesiologist", "label": "Кинезиолог" },
            { "id": "cardiologist", "label": "Кардиолог" },
            { "id": "gynecologist", "label": "Гинеколог" }
        ]
    },
    {
        "tag":"Для детей",
        "list":[
            { "id": "children-therapy-programs", "label": "Детские лечебные программы" },
            { "id": "children-leisure-organization", "label": "Организация детского досуга" },
            { "id": "animators", "label": "Аниматоры" },
            { "id": "children-birthday-organization", "label": "Организация детского дня рождения" },
            { "id": "playroom", "label": "Комната для игр" }
        ]
    },
    {
        "tag": "СПЕЦИАЛЬНОЕ МЕДИЦИНСКОЕ ОБОРУДОВАНИЕ",
        "list": [
            { "id": "mri", "label": "МРТ" },
            { "id": "inco2", "label": "Лечение углекислым газом с использованием аппарата INCO2 (газовые уколы)" },
            { "id": "water-traction", "label": "Оборудование, для водной вытяжки позвоночника" },
            { "id": "mechanical-traction", "label": "Оборудование, для механической вытяжки позвоночника" },
            { "id": "laserneedle-touch", "label": "Лазерная терапия с использованием «Laserneedle Touch»" },
            { "id": "stimawell", "label": "Электростимуляция, массаж и термотерапия с помощью аппарата «Stimawell»" },
            { "id": "magstym", "label": "Магнитотерапия с использованием «Magstym»" },
            { "id": "uva-uvb", "label": "Лечение лучами UVA-UVB" },
            { "id": "bioptron", "label": "Терапия поляризованным светом с использованием аппарата «Bioptron»" },
            { "id": "shockmaster500", "label": "Ударно-волновая терапия аппаратом «SchockMaster500»" },
            { "id": "shockmaster500-cellulite", "label": "Ударно-волновая терапия для лечения целлюлита аппаратом «SchockMaster500»" }
        ]
    }
]